import { Typography } from "@mui/material";
import React from "react";
import { STORAGE_URL } from "variables";
import OwlCarousel from "react-owl-carousel";

const CourseTestimonials = ({ testimonials }) => {
  const responsive = {
    200: {
      items: 1,
    },
    400: {
      items: 2,
    },
    1280: {
      items: 3,
    },
  };

  return (
    <div style={{ height: "max-content", position: "relative" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.4rem",
          margin: "auto",
          padding: "8rem 1rem",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="h4"
          component="div"
          sx={{
            fontFamily: "var(--Freight)",
            fontWeight: "bold",
            alignSelf: "center",
            marginBottom: "2rem",
          }}
        >
          Depoimentos dos nossos alunos
        </Typography>

        <OwlCarousel
          className="owl-theme"
          loop
          items={3}
          center
          autoplay={true}
          autoplayTimeout={5000}
          autoplayHoverPause
          responsive={responsive}
          margin={20}
          dots={false}
        >
          {testimonials.map((testimony, index) => (
            <img
              className="item"
              key={index}
              src={STORAGE_URL + testimony.image}
              alt="Depoimento"
              style={{
                width: "100%",
                maxWidth: "50rem",
                height: "max-content",
                objectFit: "contain",
                borderRadius: "0.8rem",
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
              }}
            />
          ))}
        </OwlCarousel>

        {/* <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {testimonials.map((testimony, index) => (
            <img
              key={index}
              src={STORAGE_URL+testimony.image}
              alt="Depoimento"
              style={{
                width: "100%",
                maxWidth: "30rem",
                height: "max-content",
                objectFit: "contain",
                borderRadius: "0.8rem",
                boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
              }}
            />
          ))}
        </div> */}
      </div>
    </div>
  );
};

export default CourseTestimonials;
